import { Controller } from "@hotwired/stimulus"

// Auto-refreshes the page after a configurable interval
// Usage: data-controller="auto-refresh" data-auto-refresh-interval-value="30000"
export default class extends Controller {
  static values = { interval: { type: Number, default: 30000 } }

  connect() {
    this.scheduleRefresh()
  }

  disconnect() {
    this.cancelRefresh()
  }

  scheduleRefresh() {
    this.timeout = setTimeout(() => {
      window.location.reload()
    }, this.intervalValue)
  }

  cancelRefresh() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
